module.exports = __webpack_public_path__ + "media/images/lb/475-32eb61f08668a97a77885f84b22c740b.svg";